import { WorkSheetProductStatusTypeKeys } from '@teinor/erp/types/company/order/sell/workSheet/workSheetProductStatus'
import useTwinTranslation from '../../useTwinTranslation'

interface SellProductStatusTy {
    name: string
    colorText: string
}
const useWorkSheetProductStatusType = () => {
    const { t } = useTwinTranslation()
    const workSheetProductStatus: Record<WorkSheetProductStatusTypeKeys, SellProductStatusTy> = {
        0: { name: t('general', 'General'), colorText: 'text-gray-2E' },
        1: { name: t('ready', 'Finalizado'), colorText: 'text-green-21' },
        2: { name: t('canceled', 'Cancelado'), colorText: 'text-red-BA' },
    }
    return { workSheetProductStatus }
}

export default useWorkSheetProductStatusType
